export { Stroke } from './Stroke';
